<template>
  <div
    class="text-sm font-medium ma-text-secondary grid gap-2"
    :class="{
      'grid-rows-[auto_1fr]': (canAddImage || canAddVideo) && canRegenerate,
      'grid-rows-1fr': (!canAddImage && !canAddVideo) || !canRegenerate,
    }"
    data-testid="content-edit-actions"
  >
    <div v-if="canRegenerate && toneOptions.length" class="px-4">
      <ContentEditRegenerateContent
        :tones="toneOptions"
        @compare="emit('compare', $event)"
      />
    </div>

    <ContentEditImageSection
      v-if="canAddImage || canAddVideo"
      :images="props.images"
      :videos="props.videos"
      :max-file-size="maxFileSize"
      :max-images="maxImages"
      :max-videos="maxVideos"
      :current-image-count="currentImageCount"
      :current-video-count="currentVideoCount"
      :platform="platform"
      @image-selected="emit('imageSelected', $event)"
      @video-selected="emit('videoSelected', $event)"
    />
  </div>
</template>

<script setup lang="ts">
import ContentEditRegenerateContent from "./regenerate/ContentEditRegenerateContent.vue";
import ContentEditImageSection from "./ContentEditImageSection.vue";

const props = defineProps<{
  images?: string[];
  videos?: string[];
  canRegenerate?: boolean;
  canAddImage?: boolean;
  canAddVideo?: boolean;
  maxFileSize?: number;
  tone?: string;
  maxImages?: number;
  maxVideos?: number;
  currentImageCount?: number;
  currentVideoCount?: number;
  platform?: string;
}>();

const emit = defineEmits<{
  (name: "imageSelected", payload: string): void;
  (name: "videoSelected", payload: string): void;
  (name: "compare", payload: string): void;
}>();

const toneOptions = computed(
  () =>
    props.tone
      ?.split(",")
      ?.map(tone => tone.trim())
      ?.filter(Boolean)
      ?.sort() ?? []
);
</script>
